// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__15LIq","col":"CardReaderDesc_col__2f233","label":"CardReaderDesc_label__2phYN"};